import storageService from './src/storageService'
export default new storageService()



// WEBPACK FOOTER //
// ./~/@octadesk/storage/index.js